import styled from 'styled-components';
import React, { FC } from 'react';
import { Row } from 'react-grid-system';
import { useSettings } from '../../contexts/settingsContext';

interface Props {
  radius: string;
}

const StyledListBorder = styled(Row)<Props>`
  background-color: #fafafa;
  border-bottom-left-radius: ${({ radius }) => `${radius}`};
  border-bottom-right-radius: ${({ radius }) => `${radius}`};
`;

const ListBorder: FC = ({ children }): JSX.Element => {
  const { cornerRadius: radius } = useSettings();
  return <StyledListBorder radius={radius}>{children}</StyledListBorder>;
};

export default ListBorder;
